import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
  selector: '[RestrictDecimalPlacesNumber]'
})
export class RestrictDecimalPlacesNumberDirective {
  @Input() nDecimalPlaces: number = 2;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-'];
  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    let regexString = '^\\d*\\.?\\d{0,'+ this.nDecimalPlaces + '}$';
    let regex: RegExp = new RegExp(regexString,'g');
    //console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }
}
